module.exports = __webpack_public_path__ + "static/media/influence_3stars.31340048.png";